import {
  ApiError,
  ApiErrorResponse,
  ClassifierFormDataType,
  GetApiErrorMessage,
  getExcelErrorMessage,
} from '@atlas-frontend/sdk';
import React, { FC, useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CategoryUploadDownloadActions } from '../uploadDownload/CategoryUploadDownloadActions';
import { ClassifierUploadDownloadActions } from '../uploadDownload/ClassifierUploadDownloadActions';

export interface ClassifierFormUploadDownloadActionsProps {
  id?: number;
  onError: (
    apiErrors: ApiError[],
    getErrorMessage?: GetApiErrorMessage,
  ) => void;
}

export const ClassifierFormUploadDownloadActions: FC<
  ClassifierFormUploadDownloadActionsProps
> = (props) => {
  const { id, onError } = props;

  const onUploadError = useCallback(
    (error: ApiErrorResponse) => {
      onError?.(error.response?.data.errors || [], getExcelErrorMessage);
    },
    [onError],
  );

  const form = useFormContext<ClassifierFormDataType>();

  const handleUploadSuccess = useCallback(
    (responseData: Partial<ClassifierFormDataType>) => {
      form.reset({
        ...form.getValues(),
        ...responseData,
      } as ClassifierFormDataType);
    },
    [form],
  );

  const hasCategories = useWatch<ClassifierFormDataType>({
    name: 'hasCategories',
  }) as boolean;

  return hasCategories ? (
    <CategoryUploadDownloadActions
      id={id}
      edit={true}
      onError={onUploadError}
      onSuccess={handleUploadSuccess}
    />
  ) : (
    <ClassifierUploadDownloadActions
      id={id}
      edit={true}
      onError={onUploadError}
      onSuccess={handleUploadSuccess}
    />
  );
};
